import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
 
  
  gridColumn:{
    flexDirection:'row',
    display: 'flex',
    marginTop: '16px',
    gap: '12px',
    justifyContent:'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection:'column',


    },
  },

  box: {
    position: 'relative',
  },
  mainContent: {
    padding: '20px 0 0',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '12px 0 0',

    },
  },
 
  exportBtn:{
    width: '185px',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      marginBottom:'4px'
    },
  },
  blockReport: {
    width: '190px',
    background: '#3E4EAA0D',
    boxShadow: '0px 2px 4px 0px #00000026',
    height: '136px',
    flexDirection: 'column',
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    '&.isopen':{
    
      background: '#3E4EAA26',

    },
    '& .MuiButton-label': {
      flexDirection: 'column',
      display: 'flex',
      alignContent: 'center',
      alignItems: 'center',
      gap: '20px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto',
      padding: ' 15px 0 ',
      margin: '0 ',
    },

    '& span': {
      color: '#4A4A4A',
      fontWeight: '500',
      fontSize: '14px',
    },
  },
  
  messageLoading: {
    zIndex:'10000' , 
    marginBottom:'30px', 
    fontWeight:'bold' , 
    fontSize:'16px'
   // marginTop:'50px'
  },
  loadingContent: {
    display: 'flex',
    justifyContent:'center' , 
    alignItems:'center',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    borderRadius: '34px',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
   
    },
 
  },
  contentDg: {
    overflowY: 'auto',
  }

}));
